export const GetProgramLevel = (programLevels, programLevelScore) => {
    if (Array.isArray(programLevels) === false) {
        return null
    }

    if (programLevels.length === 0) {
        return null
    }

    for (const programLevel of programLevels) {
        if (
            programLevel.levelScoreLowerBound <= programLevelScore 
            && programLevelScore <= programLevel.levelScoreUpperBound 
        ) {
            return programLevel
        }
    }

    return null
}

export const GetProgramLevelFromHashmap = (programLevelHashMap, programLevelScore) => {
    if (programLevelHashMap === null) {
        return null
    }

    for (const programLevelId in programLevelHashMap) {

        const programLevel = programLevelHashMap[programLevelId]

        if (
            programLevel.levelScoreLowerBound <= programLevelScore 
            && programLevelScore <= programLevel.levelScoreUpperBound
        ) {
            return programLevel
        }
    }

    return null
}